<template>
    <div class="tag-list">
        <Tag v-for="tag in tags" :key="tag" closable :name="tag" @onClose="onTagClose">{{ tag }}</Tag>
    </div>
</template>

<script lang="ts">
import type { PropType } from "vue";

export default {
    name: "TagList",
    props: {
        tags: {
            type: Array as PropType<string[]>,
            required: true
        }
    },

    emits: ["tagClose"],

    methods: {
        onTagClose(event: Event, tagName: string) {
            this.$emit("tagClose", tagName);
        }
    }
};
</script>

<style lang="scss">
.tag-list {
    .ivu-tag {
        font-size: 10px;
        height: auto;
        text-transform: uppercase;

        .ivu-icon-ios-close {
            margin-top: 1px;
        }
    }
}
</style>
